/* @flow weak */

'use strict';

const React = require('react');
const Reflux = require('reflux');
const _ = require('lodash');
const AnswerActions = require('../../actions/AnswerActions.jsx');
const UCStore = require('../../stores/UCStore.jsx');

const ToolbarSection = require('./ToolbarSection.jsx');
const CallToActionSection = require('./CallToActionSection.jsx');
const MessagingSection = require('./MessagingSection.jsx');
const QuestionSection = require('./QuestionSection.jsx');

const Config = require('../../configs/Config.js');

const ConfiguratorSection = React.createClass({
    mixins: [
        Reflux.connect(UCStore, 'data'),
    ],

  render() {
      let messaging;
      if (_.get(this.state.data.product, 'metadata.HolidayCutoffMessaging') || _.get(this.state.data.product, 'metadata.ProductQuickturnMessaging')) {
          messaging = (<MessagingSection productData={this.state.data} />);
      }

    return (
      <div id="uc-configurator-section">
        { Config.features.socialSharing ? <ToolbarSection section="top" /> : '' }

        <CallToActionSection section="top" productData={this.state.data} />

        {messaging}
        
        <QuestionSection />

        { Config.features.socialSharing ? <ToolbarSection section="bottom" /> : '' }

        <CallToActionSection section="bottom" productData={this.state.data} />
      </div>
    );
  }
});

module.exports = ConfiguratorSection;


// WEBPACK FOOTER //
// ./src/base/scripts/components/section/ConfiguratorSection.jsx